export default __webpack_public_path__ + "static/media/Icon-edit.4c90d02a.svg";